import {JsonProperty} from 'json-typescript-mapper/index';
import {Contact} from './contact.model';

export class MerchantContact {
  @JsonProperty('id')
  id?:                                           number = void 0;
  @JsonProperty('salutation')
  salutation?:                                   string = void 0;
  @JsonProperty('firstname')
  firstname?:                                    string = void 0;
  @JsonProperty('lastname')
  lastname?:                                     string = void 0;
  @JsonProperty('displayname')
  displayname?:                                  string = void 0;
  @JsonProperty('mobile')
  mobile?:                                       string = void 0;
  @JsonProperty('casFunction')
  casFunction?:                                  string = void 0;
  @JsonProperty('status')
  status?:                                       string = void 0;
  @JsonProperty('responsibleAccordingToTMG')
  responsibleAccordingToTMG?:                    string = void 0;
  @JsonProperty('merchantCompany')
  merchantCompany?:                              string = void 0;
  @JsonProperty('lastTermsAcceptedAt')
  lastTermsAcceptedAt?:                          string = void 0;
  @JsonProperty('merchantCompanyAdditional')
  merchantCompanyAdditional?:                    string = void 0;
  @JsonProperty('merchantNumber')
  merchantNumber?:                               string = void 0;
  @JsonProperty('merchantNoWebsiteParticipation')
  merchantNoWebsiteParticipation?:               boolean = void 0;
  @JsonProperty('merchantMarketwebsiteSelfPresentation')
  merchantMarketwebsiteSelfPresentation?:        boolean = void 0;
  @JsonProperty('merchantAdvancedMarketwebsite')
  merchantAdvancedMarketwebsite?:                boolean = void 0;
  @JsonProperty('merchantMarketwebsiteAdvertisingPresentation')
  merchantMarketwebsiteAdvertisingPresentation?: boolean = void 0;
  @JsonProperty('merchantId')
  merchantId?:                                   number = void 0;
  @JsonProperty('marketdateBoothAccountedAt')
  marketdateBoothAccountedAt?:                   string = void 0;
  @JsonProperty('marketdateBoothLastAccount')
  marketdateBoothLastAccount?:                   string = void 0;
  @JsonProperty('marketdateId')
  marketdateId?:                                 number = void 0;
  @JsonProperty('marketdateEvasiveDate')
  marketdateEvasiveDate?:                        string = void 0;
  @JsonProperty('marketdateOriginalDate')
  marketdateOriginalDate?:                       string = void 0;
  @JsonProperty('marketdayId')
  marketdayId?:                                  number = void 0;
  @JsonProperty('marketdayNumber')
  marketdayNumber?:                              string = void 0;
  @JsonProperty('marketdayTitle')
  marketdayTitle?:                               string = void 0;
  @JsonProperty('marketplaceId')
  marketplaceId?:                                number = void 0;
  @JsonProperty('marketplaceTitle')
  marketplaceTitle?:                             string = void 0;
  @JsonProperty('marketplaceNumber')
  marketplaceNumber?:                            string = void 0;
  @JsonProperty('marketplaceBranchId')
  marketplaceBranchId?:                          number = void 0;
  @JsonProperty('marketplaceBranchString')
  marketplaceBranchString?:                      string = void 0;
  @JsonProperty('marketplaceCity')
  marketplaceCity?:                              string = void 0;
  @JsonProperty('marketplaceFederalState')
  marketplaceFederalState?:                      string = void 0;
  @JsonProperty('superordinateContact')
  superordinateContact: Contact = void 0;
  @JsonProperty('noWebsiteParticipation')
  noWebsiteParticipation: boolean = void 0;
  @JsonProperty('marketwebsiteBanned')
  marketwebsiteBanned: boolean = void 0;

}



// WEBPACK FOOTER //
// ./src/app/entities/merchant-contact.model.ts